import React from 'react';

const LOGO_SRC = '/assets/brand/logo-header.png';

// Header logo is icon-only per final finish spec.
// Size prop controls the visible height in pixels.
export default function Logo({ variant = 'dark', size = 64, showWord = false, className = '' }) {
  const _ = variant; // reserved for future light-variant asset
  return (
    <div className={`inline-flex items-center ${className}`}>
      <img
        src={LOGO_SRC}
        alt="Apex Quality Control"
        style={{ height: `${size}px`, width: 'auto' }}
        className="object-contain block"
      />
      {showWord && (
        <span className="sr-only">Apex Quality Control</span>
      )}
    </div>
  );
}

export function LogoMark() {
  return null; // Deprecated — watermark logos are removed per exact-replica requirements
}
